
document.addEventListener("DOMContentLoaded", function() {

  // class名の設定
  var classNames = {
    openModal: "nodal--open",
    bodyOpen: "nodal--open",
    nodal: "nodal",
    overlay: "nodal__overlay",
    modalOpenBtn: "nodal-open",
    modalCloseBtn: "nodal-close",
    dataNodalTarget: "data-nodal-target"
  };

  // 要素を取得
  var openModalBtns = document.querySelectorAll("." + classNames.modalOpenBtn);
  var closeModalBtns = document.querySelectorAll("." + classNames.modalCloseBtn);
  var nodalContainers = document.querySelectorAll("." + classNames.nodal);
  var nodalOverlays = document.querySelectorAll("." + classNames.overlay);
  var scrollPosition = 0;

  // モーダルを開く
  function openModal(modal) {
    modal.classList.add(classNames.openModal);
    document.body.classList.add(classNames.bodyOpen);

    // モーダル内の要素のスクロール位置を初期化
    var modalElements = modal.querySelectorAll("*");
    modalElements.forEach(function(element) {
      element.scrollTop = 0;
    });

    // ウインドウのスクロール位置を保存
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.top = '-' + scrollPosition + 'px';
  }

  // モーダルを閉じる
  function closeModal(modalContainer) {
    modalContainer.classList.remove(classNames.openModal);
    document.body.classList.remove(classNames.bodyOpen);

    // ウインドウのスクロール位置を復元
    document.body.style.top = '0';
    window.scrollTo(0, scrollPosition);
  }

  // モーダルを開くボタンにクリックイベントを追加
  openModalBtns.forEach(function(openModalBtn) {
    openModalBtn.addEventListener("click", function(event) {
      var nodalTarget = this.getAttribute(classNames.dataNodalTarget);
      var modal = document.querySelector("." + nodalTarget);
      openModal(modal);
      event.preventDefault();
    });
  });

  // モーダルを閉じるボタンにクリックイベントを追加
  closeModalBtns.forEach(function(closeModalBtn) {
    closeModalBtn.addEventListener("click", function(event) {
      var modalContainer = closeModalBtn.closest("." + classNames.nodal);
      closeModal(modalContainer);
      event.preventDefault();
    });
  });

  // モーダルのオーバーレイにクリックイベントを追加
  nodalOverlays.forEach(function(nodalOverlay) {
    nodalOverlay.addEventListener("click", function(event) {
      var modalContainer = nodalOverlay.closest("." + classNames.nodal);
      if (event.target === nodalOverlay) {
        closeModal(modalContainer);
      }
      event.preventDefault();
    });
  });
});
